import { Component } from '@angular/core';
import { HttpService, HttpCall } from './http-service.service';
import {ConfirmService} from './confirm.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'gTrucks';
  user:any;
  constructor(private httpService: HttpService,private confirmService: ConfirmService) {

  }
  ngOnInit() {
    this.refresh();
  }

  refresh(){
    this.user=null;
    let call:HttpCall = {url: "enduser/userData"}
    //call.url = "http://quotes.rest/quote/random.json"

    this.httpService.GetJSONContent<any>(call) .subscribe(response => {
      this.user=response.body;
    });
  }

  logout(){
    this.confirmService.show({title:"Conferma uscita",paragraphs:["Sei certo di voler uscire da gTrucks?"]})
    .subscribe(
      (confirm)=>{ if(confirm) this.httpService.logout().subscribe(
        ()=> this.refresh()
      );}
    )
    
  }
}
